import { IImpact } from 'src/types'
import { FairtradeImpactBubble } from './fairtrade-impact-bubble.component'
import { BubbleList } from './fairtrade-impact-bubbles.styled'
import { forwardRef } from 'react'
interface IProps {
  items: IImpact[]
  withArrows?: boolean
  primaryColor: string
  walletAddress: string
  showWalletAddress: boolean
  showBcInfo: boolean
  accountImage: string
  isImpactsPage: boolean
  templateId?: string
  disabled?: boolean
}

// Colors for the bubbles
const BUBBLE_COLORS = ['#7b1dab', '#ff4571', '#bfd800']

export const FairtradeImpactBubbles = forwardRef<HTMLDivElement, IProps>(
  (
    {
      items,
      withArrows,
      primaryColor,
      walletAddress,
      showWalletAddress,
      showBcInfo,
      accountImage,
      isImpactsPage,
      templateId,
      disabled,
    },
    ref,
  ) => {
    return (
      <>
        <BubbleList id="fairtrade-impact-bubbles__list" ref={ref} withArrows={withArrows}>
          {items.map((item, index) => {
            const colorIndex = index % BUBBLE_COLORS.length
            const bubbleColor = BUBBLE_COLORS[colorIndex]
            const shapeIndex = 0

            return (
              <FairtradeImpactBubble
                key={item.id}
                id={item.id}
                title={item.quantity}
                quantityName={item.quantity_type_name || item.custom_quantity_type}
                subtitle={item.name}
                image={item.image_medium || item.image}
                unSdg={item.un_sdg}
                scans={item.scans}
                primaryColor={primaryColor}
                walletAddress={walletAddress}
                showWalletAddress={showWalletAddress}
                showBcInfo={showBcInfo}
                accountImage={accountImage}
                isImpactsPage={isImpactsPage}
                aiGenerated={item.ai_generated}
                aiVerifiedCount={item?.consumerScanInfo?.count || 0}
                aiVerifiedInfo={item?.consumerScanInfo?.data || []}
                templateId={templateId}
                bubbleColor={bubbleColor}
                shapeIndex={shapeIndex}
                description={item.description}
                media={item.media}
                mainMedia={item.mainMedia}
                likes={item.totalLikes}
                liked={item.liked}
                disabled={disabled}
              />
            )
          })}
        </BubbleList>
      </>
    )
  },
)
